import {React, styled} from 'common'
import {Link} from '@mui/material'
import {Texts} from 'appearance'
import {useTranslation} from 'react-i18next'

const ButtonNavigate = ({i18nCategory, path = '#'}) => {
    const {t} = useTranslation()
    return (
        <Link underline="none" href={path}>
            <ButtonNavigateText>{t(`${i18nCategory}.buttonNavigate`)}</ButtonNavigateText>
        </Link>
    )
}

export default ButtonNavigate

const ButtonNavigateText = styled(Texts.MediumText)`
    font-size: 12px;
`
